<template>
	<div class="page-container">
		<div class="top-content">
			<div class="searchbox mr-10">
				<input type="text" v-model="searchWord" placeholder="搜索关键词" />
			</div>
			<div class="mr-10">版本类型</div>
			<div class="mr-10">
				<el-select v-model="editionType" @change="getType" placeholder="请选择">
					<el-option v-for="item in typeList" :key="item" :label="item.label" :value="item.value">
					</el-option>
				</el-select>
			</div>
			<span class="search_btn" v-on:click="getData()">查询</span>
			<span class="add_btn" v-on:click="openAddModal()">添加</span>
		</div>

		<div class="nav_warp" v-if="editionType != 'PC'">
			<!-- <div @click="navClick('customer')" :class="editionUserType == 'customer' ? 'ac' : ''">
				客户端
			</div> -->
			<div @click="navClick('driver')" :class="editionUserType == 'driver' ? 'ac' : ''">
				司机端
			</div>
		</div>

		<div class="bottom-content">
			<div class="table-container" v-bind:id="tableId">
				<el-table v-bind:data="tableData" stripe border style="width: 100%" v-bind:max-height="tableHeight"
					v-bind:header-cell-style="{
            textAlign: 'center',
            color: '#333333',
            background: '#F5F5F5',
          }" v-bind:cell-style="{ textAlign: 'center' }" empty-text="暂无数据">
					<el-table-column prop="editionName" label="版本名称"></el-table-column>
					<el-table-column prop="editionNumber" label="内置版本编号" width="120"></el-table-column>
					<el-table-column prop="editionNo" label="版本号" width="120"></el-table-column>
					<el-table-column prop="editionType" label="版本类别" width="120">
						<template #default="scope">
							<span v-if="scope.row.editionType == 'PC'">PC端</span>
							<span v-else>{{ scope.row.editionType }}端</span>
						</template>
					</el-table-column>
					<el-table-column v-if="editionType == 'android'" prop="editionAndroidUrl" label="安卓apk"
						show-overflow-tooltip>
						<template #default="scope">
							<a class="url_text" v-if="scope.row.editionAndroidUrl"
								:href="scope.row.editionAndroidUrl">{{ scope.row.editionAndroidUrl }}</a>
							<span v-else>无</span>
						</template>
					</el-table-column>
					<el-table-column v-if="editionType == 'ios'" prop="editionAppleUrl" label="ios路径"
						show-overflow-tooltip>
						<template #default="scope">
							<span v-if="scope.row.editionAppleUrl">{{
                scope.row.editionAppleUrl
              }}</span>
							<span v-else>无</span>
						</template>
					</el-table-column>
					<el-table-column prop="editionQzUpdat" label="强制更新" v-if="editionType != 'PC'">
						<template #default="scope">
							<span v-if="scope.row.editionQzUpdat == '1'">是</span>
							<span v-else>否</span>
						</template>
					</el-table-column>
					<el-table-column prop="editionUser" label="版本发布人"></el-table-column>
					<el-table-column prop="editionTime" label="版本发布时间" show-overflow-tooltip>
						<template #default="scope">
							<span>{{ formatDatetime(scope.row.editionTime) }}</span>
						</template>
					</el-table-column>
					<el-table-column label="操作">
						<template #default="scope">
							<span class="col-blue operation-text mr-20" v-if="scope.row.editionNew == 'Y'"
								v-on:click="openEditModal(scope.row.editionId)">编辑</span>
							<span class="col-blue operation-text mr-20"
								v-on:click="openDetailModal(scope.row.editionId)">详情</span>
							<span class="col-blue operation-text" v-on:click="deleteInfo(scope.row.editionId)">删除</span>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div class="flex flex-y-center flex-x-center">
				<el-pagination style="margin-top: 25px" background layout="sizes, prev, pager, next, total, jumper"
					v-bind:page-sizes="[10, 20, 50, 100]" v-bind:total="totalCount" v-on:size-change="getData()"
					v-on:current-change="getData()" v-model:current-page="currentPage"
					v-model:page-size="pageSize"></el-pagination>
			</div>
		</div>

		<!-- 添加 -->
		<el-dialog title="添加" v-model="showAddModal" width="40%" center>
			<div class="">
				<div class="dialog-row" v-if="editionUserType == 'customer'">
					<span>版本名称：</span>

					<div class="input-box">
						<el-input placeholder="请输入" v-model="addItem.editionName" v-if="disabled == false"></el-input>
						<el-input placeholder="请输入" v-model="addItem.editionName" v-else readonly></el-input>
					</div>
				</div>

				<div class="dialog-row" v-if="editionUserType == 'driver'">
					<span>版本名称：</span>

					<div class="input-box">
						<el-input placeholder="请输入" v-model="addItem.editionName" v-if="disabled == false"></el-input>
						<el-input placeholder="请输入" v-model="addItem.editionName" v-else readonly></el-input>
					</div>
				</div>

				<div class="dialog-row">
					<span>内置版本编号：</span>

					<div class="input-box">
						<el-input placeholder="请输入" v-model="addItem.editionNumber"></el-input>
					</div>
				</div>

				<div class="dialog-row">
					<span>版本号：</span>

					<div class="input-box">
						<el-input placeholder="请输入" v-model="addItem.editionNo"></el-input>
					</div>
				</div>

				<div class="dialog-row" v-if="editionType == 'android'">
					<span>安卓apk：</span>
					<div class="input-box">
						<el-upload ref="upload" class="upload-demo" action="#" accept=".apk" :auto-upload="false"
							:on-change="uploadFile" :show-file-list="false">
							<el-button type="warning">导入文件</el-button>
						</el-upload>
					</div>
				</div>
				<div class="dialog-row" v-if="editionType == 'android' && addItem.editionAndroidUrl">
					<span>安卓路径：</span>

					<div class="input-box">
						<el-input placeholder="请输入" v-model="addItem.editionAndroidUrl" readonly></el-input>
					</div>
				</div>
				<div class="dialog-row" v-if="editionType == 'ios'">
					<span>ios路径：</span>

					<div class="input-box">
						<el-input placeholder="请输入" v-model="addItem.editionAppleUrl"></el-input>
					</div>
				</div>
				<div class="dialog-row" v-if="editionType == 'android'">
					<span>安卓商店：</span>
					<div class="input-box">
						<el-checkbox label="华为" v-model="addItem.editionHuawei"></el-checkbox>
						<el-checkbox label="小米" v-model="addItem.editionMi"></el-checkbox>
						<el-checkbox label="oppo" v-model="addItem.editionOppo"></el-checkbox>
						<el-checkbox label="vivo" v-model="addItem.editionVivo"></el-checkbox>
					</div>
				</div>
				<div class="dialog-row">
					<span>版本类型：</span>

					<div class="input-box">
						<el-input placeholder="请输入" v-model="editionType" readonly></el-input>
					</div>
				</div>

				<div class="dialog-row">
					<span>强制更新：</span>

					<div class="input-box">
						<el-select v-model="addItem.editionQzUpdat">
							<el-option label="否" value="0"> </el-option>
							<el-option label="是" value="1"> </el-option>
						</el-select>
					</div>
				</div>

				<div class="dialog-row" style="height: auto">
					<span>版本简介：</span>

					<div class="input-box">
						<el-input type="textarea" placeholder="请输入内容" v-model="addItem.editionIntroduce" maxlength="100"
							:rows="2" show-word-limit>
						</el-input>
					</div>
				</div>
			</div>
			<template #footer>
				<span class="dialog-footer">
					<span class="btn btn-outline-default mr-50" v-on:click="closeAddModal()">取消</span>
					<span class="btn bg-default" v-on:click="submitAddInfo()">确定</span>
				</span>
			</template>
		</el-dialog>
		<!-- 添加 end -->
		<!-- 编辑 -->
		<el-dialog title="编辑" v-model="showEditModal" width="40%" center>
			<div class="">
				<div class="dialog-row">
					<span>版本名称：</span>

					<div class="input-box">
						<el-input placeholder="请输入" v-model="editItem.editionName"></el-input>
					</div>
				</div>
				<div class="dialog-row">
					<span>内置版本编号：</span>

					<div class="input-box">
						<el-input placeholder="请输入" v-model="editItem.editionNumber"></el-input>
					</div>
				</div>
				<div class="dialog-row">
					<span>版本号：</span>

					<div class="input-box">
						<el-input placeholder="请输入" v-model="editItem.editionNo"></el-input>
					</div>
				</div>
				<div class="dialog-row" v-if="editionType == 'android'">
					<span>安卓apk：</span>
					<div class="input-box">
						<el-upload ref="upload" class="upload-demo" action="#" accept=".apk" :auto-upload="false"
							:on-change="uploadFile" :show-file-list="false">
							<el-button type="warning">导入文件</el-button>
						</el-upload>
					</div>
				</div>
				<div class="dialog-row" v-if="editionType == 'android' && editItem.editionAndroidUrl">
					<span>安卓路径：</span>

					<div class="input-box">
						<el-input placeholder="请输入" v-model="editItem.editionAndroidUrl" readonly></el-input>
					</div>
				</div>
				<div class="dialog-row" v-if="editionType == 'android'">
					<span>安卓商店：</span>
					<div class="input-box">
						<el-checkbox label="华为" v-model="editItem.editionHuawei"></el-checkbox>
						<el-checkbox label="小米" v-model="editItem.editionMi"></el-checkbox>
						<el-checkbox label="oppo" v-model="editItem.editionOppo"></el-checkbox>
						<el-checkbox label="vivo" v-model="editItem.editionVivo"></el-checkbox>
					</div>
				</div>
				<div class="dialog-row" v-if="editionType == 'ios'">
					<span>ios路径：</span>

					<div class="input-box">
						<el-input placeholder="请输入" v-model="editItem.editionAppleUrl"></el-input>
					</div>
				</div>

				<div class="dialog-row">
					<span>版本类型：</span>

					<div class="input-box">
						<el-input placeholder="请输入" v-model="editionType" readonly></el-input>
					</div>
				</div>

				<div class="dialog-row">
					<span>强制更新：</span>

					<div class="input-box">
						<el-select v-model="editItem.editionQzUpdat">
							<el-option label="否" :value="0"> </el-option>
							<el-option label="是" :value="1"> </el-option>
						</el-select>
					</div>
				</div>

				<div class="dialog-row" style="height: auto">
					<span>版本简介：</span>

					<div class="input-box">
						<el-input type="textarea" placeholder="请输入内容" v-model="editItem.editionIntroduce"
							maxlength="100" :rows="2" show-word-limit>
						</el-input>
					</div>
				</div>
			</div>
			<template #footer>
				<span class="dialog-footer">
					<span class="btn btn-outline-default mr-50" v-on:click="closeEditModal()">取消</span>
					<span class="btn bg-default" v-on:click="submitEditInfo()">确定</span>
				</span>
			</template>
		</el-dialog>
		<!-- 编辑--end -->
		<!-- 详情 -->
		<el-dialog title="详情" v-model="showDetailsModal" width="40%" center>
			<div class="">
				<div class="dialog-row">
					<span>版本名称：</span>

					<div class="input-box">
						<el-input placeholder="请输入" v-model="editItem.editionName" readonly></el-input>
					</div>
				</div>
				<div class="dialog-row">
					<span>内置版本编号：</span>

					<div class="input-box">
						<el-input placeholder="请输入" v-model="editItem.editionNumber" readonly></el-input>
					</div>
				</div>
				<div class="dialog-row">
					<span>版本号：</span>

					<div class="input-box">
						<el-input placeholder="请输入" v-model="editItem.editionNo" readonly></el-input>
					</div>
				</div>

				<div class="dialog-row">
					<span>版本类型：</span>

					<div class="input-box">
						<el-input placeholder="请输入" v-model="editionType" readonly></el-input>
					</div>
				</div>
				<div class="dialog-row" v-if="editionType == 'android'">
					<span>安卓apk：</span>

					<div class="input-box">
						<el-input placeholder="请输入" v-model="editItem.editionAndroidUrl" readonly></el-input>
					</div>
				</div>
				<div class="dialog-row" v-if="editionType == 'ios'">
					<span>ios路径：</span>

					<div class="input-box">
						<el-input placeholder="请输入" v-model="editItem.editionAppleUrl" readonly></el-input>
					</div>
				</div>

				<div class="dialog-row">
					<span>&emsp;发布者：</span>

					<div class="input-box">
						<el-input placeholder="请输入" v-model="editItem.editionUser" readonly></el-input>
					</div>
				</div>

				<div class="dialog-row">
					<span>发布时间：</span>

					<div class="input-box">
						<el-input placeholder="请输入" v-model="editItem.editionTime" readonly></el-input>
					</div>
				</div>

				<div class="dialog-row">
					<span>强制更新：</span>

					<div class="input-box">
						<el-select v-model="editItem.editionQzUpdat" disabled>
							<el-option label="否" :value="0"> </el-option>
							<el-option label="是" :value="1"> </el-option>
						</el-select>
					</div>
				</div>

				<div class="dialog-row" style="height: auto">
					<span>版本简介：</span>

					<div class="input-box">
						<el-input type="textarea" placeholder="请输入内容" v-model="editItem.editionIntroduce"
							maxlength="100" :rows="2" show-word-limit readonly>
						</el-input>
					</div>
				</div>
			</div>
			<template #footer>
				<span class="dialog-footer">
					<span class="btn bg-default" v-on:click="closeDetailModal()">关闭</span>
				</span>
			</template>
		</el-dialog>

		<!-- 详情--end -->

		<div class="mask" v-if="isShowProgress">
			<img style="width: 500px; height: auto" src="../../assets/images/upgif.gif" alt="" />
			<!-- <div class="progress_box">
       
        <div class="progress_tit">上传进度</div>
        <div class="progress_content">
          <el-progress
            :text-inside="true"
            :stroke-width="14"
            :percentage="progress"
            status="success"
          />
        </div>
        <div class="progress_text">上传中,请稍后...</div>
      </div> -->
		</div>
	</div>
</template>

<script>
	import {
		formatDatetime,
		imgFileToBase64
	} from "@/libs/tools";
	import {
		toNestedArr
	} from "element-plus/lib/components/calendar/src/date-table";
	import {
		th,
		tr
	} from "element-plus/lib/locale";
	import axios from "axios";
	import zhCn from "element-plus/es/locale/lang/zh-cn";
	export default {
		name: "versionManage",
		data() {
			return {
				urlPrefix: "/admin",
				tableId: "systemVersion",
				tableHeight: 0,

				pageSize: 10,
				totalCount: 0,
				currentPage: 1,

				searchWord: "",
				editionType: "android",
				editionUserType: "driver", //customer客户端；driver司机端;manage管理端
				tableData: [],
				typeList: [{
						value: "PC",
						label: "PC端",
					},
					{
						value: "android",
						label: "android端",
					},
					{
						value: "ios",
						label: "ios端",
					},
				],

				showAddModal: false,
				customerLogo: "",
				customerName: "",
				customerIco: "",
				customerIntroduce: "",
				rptLogo: "",
				rptName: "",
				rptIco: "",
				rptIntroduce: "",
				addItem: {
					editionLogo: "https://jiudeloan.oss-cn-hangzhou.aliyuncs.com/loan/config/2021-05-31/68269d08-0345-4b88-a90c-b117d8811951.png", //logo
					editionName: "", //名称
					editionNo: "", //编号
					editionIntroduce: "", //简介

					editionAndroidUrl: "", //安卓
					editionAppleUrl: "", //ios
					editionQzUpdat: "0", //是否强制更新
					editionNumber: "",
					editionHuawei: false,
					editionOppo: false,
					editionMi: false,
					editionVivo: false,
				},

				showEditModal: false,
				editItem: {
					editionId: "",
					editionLogo: "", //logo
					editionName: "", //名称
					editionNo: "", //编号
					editionIntroduce: "", //简介
					editionAndroidUrl: "", //安卓
					editionAppleUrl: "", //ios
					editionQzUpdat: "0", //是否强制更新
					editionNumber: "",
					editionHuawei: false,
					editionOppo: false,
					editionMi: false,
					editionVivo: false,
				},
				showDetailsModal: false,
				disabled: false,
				progress: 0, //进度条
				isShowProgress: false,
				customerId: "", //顾客iosId
				rptId: "", //司机iosId
			};
		},

		methods: {
			getInfo() {
				let sendData = {
					type: "APP"
				};
				this.$http.postFormData("/admin/bdzl/edition/getEditByType", sendData).then((res) => {
					if (res.respCode == "0000") {
						res.data.forEach((item) => {
							console.log(item);
							if (item.editionUserType == "customer") {
								this.customerName = item.editionName;
								this.customerLogo = item.editionLogo;
								this.customerIco = item.titleLogo;
								this.customerIntroduce = item.editionIntroduce;
							}
							if (
								item.editionUserType == "customer" &&
								item.editionType == "ios"
							) {
								this.customerId = item.editionAppleUrl;
							}
							if (item.editionUserType == "driver") {
								//this.androidUrl = item.editionAndroidUrl;
								this.rptLogo = item.editionLogo;
								this.rptName = item.editionName;
								this.rptIco = item.titleLogo;
								this.rptIntroduce = item.editionIntroduce;
							}
							if (item.editionUserType == "driver" && item.editionType == "ios") {
								this.rptId = item.editionAppleUrl;
							}
						});
					}
				});
			},
			navClick(type) {
				this.currentPage = 1;
				this.tableData = [];
				this.editionUserType = type;
				this.getData();
			},
			getType() {
				this.getData();
			},
			formatDatetime(time) {
				return formatDatetime(time);
			},

			getData() {
				var that = this;

				this.$http
					.get("/admin/bdzl/edition/list", {
						searchWord: this.searchWord,
						page: that.currentPage,
						limit: that.pageSize,
						editionType: that.editionType,
						editionUserType: that.editionType == "PC" ? "" : that.editionUserType,
					})
					.then((res) => {
						if (res.code == 0 || res.respCode == "0000") {
							that.tableData = res.rows;
							that.totalCount = res.total;
						} else {
							that.$message.info(res.msg || res.respMsg);
						}
					});
			},

			openAddModal() {
				this.addItem.editionLogo = null;
				this.addItem.titleLogo = null;
				this.addItem.editionName = "";
				if (this.editionType != "PC" && this.editionUserType == "customer") {
					// this.addItem.editionLogo = this.customerLogo;
					// this.addItem.titleLogo = this.customerIco;
					this.addItem.editionName = this.customerName;
					this.addItem.editionIntroduce = this.customerIntroduce;
					this.addItem.editionAppleUrl = this.customerId;
				}
				if (this.editionType != "PC" && this.editionUserType == "driver") {
					// this.addItem.editionLogo = this.rptLogo;
					// this.addItem.titleLogo = this.rptIco;
					this.addItem.editionName = this.rptName;
					this.addItem.editionIntroduce = this.rptIntroduce;
					this.addItem.editionAppleUrl = this.rptId;
				}
				// if (this.editionType != "PC") {
				//   console.log("aa");
				//   this.$http
				//     .get(
				//       "/admin/bdzl/edition/getBig",
				//       { type: "APP", userType: this.editionUserType },
				//       {
				//         headers: { "Content-Type": "application/x-www-form-urlencoded" },
				//       }
				//     )
				//     .then((res) => {
				//       if (res.respCode == "0000") {
				//         if (res.data && res.data.length > 0) {
				//           console.log(res.data)
				//           res.data.forEach((item) => {
				//             if (item.editionUserType == "customer") {
				//               this.disabled = true;
				//               this.addItem.editionLogo = item.editionLogo;
				//               this.addItem.editionName = item.editionName;
				//               this.addItem.titleLogo = item.titleLogo;
				//               this.showAddModal = true;

				//             }
				//             if (item.editionUserType == "phy") {
				//               this.disabled = true;
				//               this.addItem.editionLogo = item.editionLogo;
				//               this.addItem.editionName = item.editionName;
				//               this.addItem.titleLogo = item.titleLogo;
				//               this.showAddModal = true;
				//             }
				//           });
				//         }
				//       }
				//     });
				//   return;
				// }
				this.showAddModal = true;
			},
			handleAddUploadChange(file, fileList) {
				imgFileToBase64(file, (imageUrl) => {
					this.addItem.editionLogo = imageUrl;
				});
			},
			handleAddUploadChangeIco(file, fileList) {
				imgFileToBase64(file, (imageUrl) => {
					this.addItem.titleLogo = imageUrl;
					this.editItem.titleLogo = imageUrl;
				});
			},
			//添加
			submitAddInfo() {
				//  editionHuawei: false,
				// editionOppo: false,
				// editionMi: false,
				// editionVivo: false,
				var that = this;
				that.addItem.editionHuawei =
					that.addItem.editionHuawei == true ? "1" : "2";
				that.addItem.editionOppo = that.addItem.editionOppo == true ? "1" : "2";
				that.addItem.editionMi = that.addItem.editionMi == true ? "1" : "2";
				that.addItem.editionVivo = that.addItem.editionVivo == true ? "1" : "2";
				if (that.addItem.editionName == "") {
					that.$message.error("请填写版本名称");
					return;
				}
				// if (that.addItem.editionLogo == "") {
				// 	that.$message.error("请上传版本logo");
				// 	return;
				// }
				// if (that.addItem.titleLogo == "") {
				// 	that.$message.error("请上传版本ico");
				// 	return;
				// }
				if (that.addItem.editionNumber == "") {
					that.$message.error("请填写内置版本编号");
					return;
				}
				if (that.addItem.editionNo == "") {
					that.$message.error("请填写版本号");
					return;
				}

				if (
					that.addItem.editionAndroidUrl == "" &&
					this.editionType == "android"
				) {
					that.$message.error("请上传安卓apk");
					return;
				}
				if (that.addItem.editionAppleUrl == "" && this.editionType == "ios") {
					that.$message.error("请输入ios路径");
					return;
				}

				this.addItem.editionType = this.editionType;
				this.addItem.editionUserType = this.editionUserType;
				that.$http.post("/admin/bdzl/edition/save", that.addItem).then((res) => {
					if (res.code == 0 || res.respCode == "0000") {
						that.$message.success(res.msg || res.respMsg);
						that.showAddModal = false;
						that.getData();
						this.addItem.editionName = "";
						this.addItem.editionNo = "";
						this.addItem.editionIntroduce = "";
						that.updateIco();
					} else {
						that.$message.info(res.msg || res.respMsg);
					}
				});
			},
			closeAddModal() {
				this.showAddModal = false;
			},
			closeEditModal() {
				this.showEditModal = false;
			},
			deleteInfo(deleteId) {
				this.$confirm("您确定删除选中的数据吗", "提示", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning",
				}).then(() => {
					this.$http
						.postFormData("admin/bdzl/edition/remove", {
							editionId: deleteId
						})
						.then((res) => {
							if (res.respCode == "0000") {
								this.$message.success(res.msg || res.respMsg);
								this.getData();
							} else {
								this.$message.info(res.msg || res.respMsg);
							}
						});
				});
			},

			openEditModal(editionId) {
				var that = this;

				this.showEditModal = true;
				this.$http
					.postFormData("/admin/bdzl/edition/edit", {
						editionId: editionId
					})
					.then((res) => {
						this.editItem.editionId = res.data.editionId;
						this.editItem.editionLogo = null;
						this.editItem.editionName = res.data.editionName;
						this.editItem.editionNo = res.data.editionNo;
						this.editItem.editionIntroduce = res.data.editionIntroduce;
						this.editItem.titleLogo = null;
						this.editItem.editionAppleUrl = res.data.editionAppleUrl;
						this.editItem.editionAndroidUrl = res.data.editionAndroidUrl;
						this.editItem.editionQzUpdat = res.data.editionQzUpdat;
						this.editItem.editionNumber = res.data.editionNumber;
						this.editItem.editionHuawei =
							this.editItem.editionHuawei == 1 ? true : false;
						this.editItem.editionOppo =
							this.editItem.editionOppo == 1 ? true : false;
						this.editItem.editionMi = this.editItem.editionMi == 1 ? true : false;
						this.editItem.editionVivo =
							this.editItem.editionVivo == 1 ? true : false;
					});
			},
			handleEditUploadChange(file, fileList) {
				imgFileToBase64(file, (imageUrl) => {
					this.editItem.editionLogo = imageUrl;
				});
			},
			//编辑--提交
			submitEditInfo() {
				var that = this;
				that.editItem.editionHuawei =
					that.editItem.editionHuawei == true ? "1" : "2";
				that.editItem.editionOppo = that.editItem.editionOppo == true ? "1" : "2";
				that.editItem.editionMi = that.editItem.editionMi == true ? "1" : "2";
				that.editItem.editionVivo = that.editItem.editionVivo == true ? "1" : "2";
				if (that.editItem.editionName == "") {
					that.$message.error("请填写版本名称");
					return;
				}
				// if (that.editItem.editionLogo == "") {
				// 	that.$message.error("请上传版本logo");
				// 	return;
				// }
				// if (that.editItem.titleLogo == "") {
				// 	that.$message.error("请上传版本ico");
				// 	return;
				// }
				if (
					that.editItem.editionAndroidUrl == "" &&
					this.editionType == "android"
				) {
					that.$message.error("请上传安卓apk");
					return;
				}
				if (that.editItem.editionAppleUrl == "" && this.editionType == "ios") {
					that.$message.error("请输入ios路径");
					return;
				}
				if (that.editItem.editionNumber == "") {
					that.$message.error("请填写版本号");
					return;
				}
				if (that.editItem.editionNo == "") {
					that.$message.error("请填写版本号");
					return;
				}

				this.editItem.editionType = this.editionType;
				this.editItem.editionUserType = this.editionUserType;
				that.$http
					.post("/admin/bdzl/edition/update", that.editItem)
					.then((res) => {
						if (res.code == 0 || res.respCode == "0000") {
							that.$message.success(res.msg || res.respMsg);
							that.showEditModal = false;
							that.getData();
							that.updateIco();
						} else {
							that.$message.info(res.msg || res.respMsg);
						}
					});
			},
			closeEditModal() {
				this.showEditModal = false;
			},
			//详情
			openDetailModal(editionId) {
				this.showDetailsModal = true;

				this.$http
					.postFormData("/admin/bdzl/edition/edit", {
						editionId: editionId
					})
					.then((res) => {
						this.editItem.editionId = res.data.editionId;
						this.editItem.editionLogo = null;
						this.editItem.editionName = res.data.editionName;
						this.editItem.editionNo = res.data.editionNo;
						this.editItem.editionIntroduce = res.data.editionIntroduce;
						this.editItem.titleLogo = null;
						this.editItem.editionQzUpdat = res.data.editionQzUpdat;
					});
			},
			//详情--关闭
			closeDetailModal() {
				this.showDetailsModal = false;
			},
			updateIco() {
				// 触发 leftNav中更新ico事件
				this.$nextTick(function() {
					this.$bus.emit("changePageIco", {});
				});
			},
			uploadFile(row) {
				console.log(row);
				if (row.name.indexOf(".apk") == -1) {
					this.$message.error("请选择apk文件");
					return;
				}
				let formData = new FormData();
				let file = row.raw;
				formData.append("file", file);
				formData.append("objType", "android");
				var config = {
					onUploadProgress: (progressEvent) => {
						this.isShowProgress = true;
						// var complete =
						//   ((progressEvent.loaded / progressEvent.total) * 100) | 0;
						// this.progress = complete;
						// if (this.progress == 100) {
						//   this.progress = 99;
						// }
						// console.log(this.progress);
					},
					headers: {
						// "Content-Type": "application/json;charSet=UTF-8",
						"Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
					},
				};

				axios
					.post("/api/ossUpload/splitScreenUpload", formData, config)
					.then((res) => {
						let data = res.data;
						console.log(res);
						if (data.respCode == "0000") {
							// this.progress = 100;
							this.isShowProgress = false;
							this.addItem.editionAndroidUrl = data.data;
							this.editItem.editionAndroidUrl = data.data;
							this.$message.success("上传成功");
						} else {
							this.isShowProgress = false;
							this.progress = 0;
							this.$message.error("上传失败");
						}
					});

				// this.$http
				//   .postFormData("/api/ossUpload/multipartFileuploadToOSS", formData)
				//   .then((res) => {
				//     console.log(res);
				//     this.addItem.editionAndroidUrl = res;
				//     this.editItem.editionAndroidUrl = res;
				//     this.$message.success("上传成功");
				//   });
			},
		},

		created() {
			this.getInfo();
			this.getData();
		},
		mounted() {
			this.$nextTick(() => {
				this.tableHeight = document.querySelector(
					".bottom-content .table-container#" + this.tableId
				).offsetHeight;
				console.log(this.tableHeight);
			});

			window.onresize = () => {
				this.$nextTick(() => {
					var offsetHeight = document.querySelector(
						".bottom-content .table-container#" + this.tableId
					).offsetHeight;
					if (offsetHeight <= 0) {
						return false;
					}
					this.tableHeight = document.querySelector(
						".bottom-content .table-container#" + this.tableId
					).offsetHeight;
				});
			};
		},
	};
</script>

<style scoped>
	.dialog-row {
		display: flex;
		margin-bottom: 20px;
	}

	.dialog-row .input-box {
		width: 80%;
	}

	.url_text {
		width: 100%;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
	}

	.nav_warp {
		width: 100%;
		padding: 5px 0px;
		display: flex;
		align-items: center;
		justify-content: flex-start;
		background: #fff;
	}

	.nav_warp>div {
		width: 192px;
		padding: 5px 0px;
		background: #ffffff;
		border: 1px solid #2eb779;
		border-radius: 10px;
		cursor: pointer;
		text-align: center;
		font-size: 16px;
		color: #999;
		margin-left: 20px;
	}

	.nav_warp>.ac {
		color: #fff;
		background: #e36a19;
	}

	.page-container .top-content {
		margin-bottom: 0px;
	}

	.page-container .bottom-content {
		width: 100%;
		height: calc(100% - 110px);
		background: #ffffff;
	}

	.mask {
		width: 100%;
		height: 100%;
		background: rgba(0, 0, 0, 0.7);
		position: fixed;
		left: 0;
		top: 0;
		z-index: 100000;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.progress_box {
		width: 40%;
		padding: 20px 0;
		background: #ffffff;
		border-radius: 5px;
	}

	.progress_tit {
		width: 100%;
		font-size: 16px;
		color: #333;
		margin-left: 20px;
		text-align: left;
	}

	.progress_content {
		width: calc(100% - 40px);
		margin-left: 20px;
		margin-right: 20px;
		margin-top: 20px;
	}

	.progress_text {
		margin-top: 20px;
		font-size: 14px;
		text-align: center;
	}
</style>